export const migrations = {
  0: state => state,
  1: prevState => ({
    ...prevState,
    player: {
      ...prevState.player,
      queue: prevState.player.queue.map(
        sId =>
          sId && {
            id: sId,
            priority: 1,
            data: prevState.songs.songsById[sId],
          }
      ),
    },
  }),
  2: prevState => {
    const { darkMode, ...state } = prevState
    return {
      ...state,
      userPreferences: {
        ...state.userPreferences,
        darkMode,
      },
    }
  },
  3: prevState => {
    // eslint-disable-next-line no-unused-vars
    const { songs, ...state } = prevState
    return {
      ...state,
    }
  },
}
